<template>
	<div
		id="map"
		:class="fullscreenMap || ''"
	>
		<v-snackbar
			v-model="snackbar"
			bottom
			right
			:timeout="6000"
		>
			{{ snackbarText }}
			<v-btn
				color="blue"
				text
				@click="snackbar = false"
			>
				Close
			</v-btn>
		</v-snackbar>
		<v-btn
			v-if="!isPresentationMode"
			ref="mapDirectionBtn"
			color="red"
			class="map-direction px-1"
			title="นำทางไปยังทรัพย์นี้"
			fab
			dark
			small
			:href="'http://maps.google.com/maps?daddr=' + propLocationString"
			target="_blank"
			:on-click="`fbq('track', 'Navigator.Property.${property.id}');`"
		>
			<v-icon>mdi-directions</v-icon>
		</v-btn>
		<v-btn
			ref="mapShareBtn"
			color="red"
			class="map-share px-1"
			title="แชร์แผนที่ของทรัพย์นี้"
			fab
			dark
			small
			:on-click="`fbq('track', 'Share.Property.${property.id}');`"
			@click="mapShareShow"
		>
			<v-icon>mdi-share</v-icon>
		</v-btn>
		<v-menu
			v-model="mapShare"
			:close-on-content-click="false"
			:nudge-width="400"
			:position-x="mapShareX"
			:position-y="mapShareY"
			max-width="400"
			z-index="1000"
			bottom
			left
			offset-y
		>
			<v-card class="px-4 py-7">
				<h4>แชร์เลย</h4>
				<v-row>
					<v-col cols="6">
						<v-btn
							width="100%"
							color="indigo lighten-1 white--text"
						>
							<v-icon class="mr-1">
								mdi-facebook-messenger
							</v-icon> Messenger
						</v-btn>
					</v-col>
					<v-col cols="6">
						<mail
							width="100%"
							color="yellow darken-3 white--text"
							mail=" "
							:params="shareParams"
							:title="`แชร์ ${property.property_title} ให้ทางเมลล์`"
							:url="`https://url.tb.co.th/${isPresentationMode ? 'presentation' : 'p'}/${property.id}`"
						>
							<v-icon class="mr-1">
								mdi-email-outline
							</v-icon> อีเมล
						</mail>
					</v-col>
					<v-col cols="6">
						<facebook-share
							width="100%"
							color="indigo darken-2 white--text"
							:params="shareParams"
							:url="`https://url.tb.co.th/${isPresentationMode ? 'presentation' : 'p'}/${property.id}`"
						>
							<v-icon class="mr-1">
								mdi-facebook
							</v-icon> Facebook
						</facebook-share>
					</v-col>
					<v-col cols="6">
						<line-share
							width="100%"
							color="light-green darken-1 white--text"
							:params="shareParams"
							:url="`https://url.tb.co.th/${isPresentationMode ? 'presentation' : 'p'}/${property.id}`"
						>
							<v-icon class="mr-1">
								mdi-chat-outline
							</v-icon> Line
						</line-share>
					</v-col>
					<v-col cols="6">
						<twitter-share
							width="100%"
							color="light-blue accent-1 white--text"
							:params="shareParams"
							:url="`https://url.tb.co.th/${isPresentationMode ? 'presentation' : 'p'}/${property.id}`"
						>
							<v-icon class="mr-1">
								mdi-twitter
							</v-icon> Twitter
						</twitter-share>
					</v-col>
					<!-- <v-col cols="6">
						<v-btn
							width="100%"
							color="grey darken-2 white--text"
						>
							<v-icon class="mr-1">
								mdi-chat
							</v-icon> SMS
						</v-btn>
					</v-col> -->
					<v-col cols="6">
						<v-btn
							width="100%"
							color="grey darken-3 white--text"
							@click="copyText($refs.propertyUrl, shareParams)"
						>
							<v-icon class="mr-1">
								mdi-link-variant
							</v-icon> คัดลอกลิงค์
						</v-btn>
						<input
							ref="propertyUrl"
							type="text"
							class="d-none"
							style="border: none !important;"
						>
					</v-col>
					<v-col cols="6">
						<v-btn
							color="red"
							title="share location ของทรัพย์นี้"
							width="100%"
							style="text-transform: capitalize;"
							target="_blank"
							:href="'http://maps.google.com/maps?q=' + propLocationString"
							dark
							:on-click="`fbq('track', 'Navigator.Property.${property.id}');`"
						>
							<v-icon>mdi-map-marker</v-icon> แชร์ location
						</v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-menu>
		<v-btn
			class="exit-fullscreen"
			fab
			dark
			small
			color="red"
			@click="exitFullScreen"
		>
			<v-icon dark>
				mdi-close
			</v-icon>
		</v-btn>
		<div class="near-by-list bgWhite">
			<v-container class="px-0 py-1">
				<v-row no-gutters>
					<v-col cols="1">
						<v-btn
							icon
							@click="exitFullScreen"
						>
							<v-icon>mdi-chevron-left</v-icon>
						</v-btn>
					</v-col>
					<v-col cols="10">
						<p class="mb-0 pt-1 text-truncate">
							{{ property.locationText }}
						</p>
					</v-col>
					<!-- <v-col
						class="text-right"
						cols="2"
					>
						<v-menu
							offset-y
							bottom
							left
							min-width="300"
							max-width="100%"
							:close-on-content-click="false"
						>
							<template v-slot:activator="{ on }">
								<v-btn
									icon
									v-on="on"
								>
									<v-icon>mdi-plus-circle</v-icon>
								</v-btn>
							</template>
							<v-card>
								<v-container>
									<v-row no-gutters>
										<v-col cols="10">
											Map Type
										</v-col>
										<v-col
											cols="2"
											class="text-right"
										>
											<v-btn icon>
												<v-icon>mdi-close-circle-outline</v-icon>
											</v-btn>
										</v-col>
										<v-col
											cols="4"
											class="px-2 mapType"
										>
											<v-btn>
												<v-img
													src="images/google-map.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="100%"
													height="60"
												/>
											</v-btn>
										</v-col>
										<v-col
											cols="4"
											class="px-2 mapType"
										>
											<v-btn>
												<v-img
													src="images/google-earth.jpg"
													lazy-src="https://picsum.photos/id/11/10/6"
													aspect-ratio="1"
													class="grey lighten-2"
													max-width="100%"
													height="60"
												/>
											</v-btn>
										</v-col>
									</v-row>
								</v-container>
							</v-card>
						</v-menu>
					</v-col> -->
					<v-col
						class="my-md-1 px-0 tabLayout"
						cols="12"
					>
						<v-divider />
						<v-tabs
							v-model="placeTypeTab"
							color="red"
							grow
						>
							<v-tab
								href="#communications"
								@click="placeTypeTab = 'communications'"
							>
								การเดินทาง
							</v-tab>
							<v-tab
								href="#local_place"
								@click="placeTypeTab = 'local_place'"
							>
								สถานที่ใกล้เคียง
							</v-tab>
							<!-- <v-tab
								href="#lifestyle"
								@click="placeTypeTab = 'lifestyle'"
							>
								อื่นๆ
							</v-tab> -->
						</v-tabs>

						<v-tabs-items v-model="placeTypeTab">
							<v-tab-item value="communications">
								<v-card flat>
									<v-card-text class="py-0">
										<v-row>
											<v-col
												cols="12"
												class="pb-0 py-md-3"
											>
												<div class="borderBoxShadow searchLocation">
													<nearbyAutocomplete
														:property-location="propLocation"
														:place-selected="onPlaceSelected"
														class="mb-2"
													/>
													<!-- <v-text-field
														ref="placeSearch"
														solo
														hide-details
														placeholder="การเดินทางไปทำงาน/เรียน จากตรงนี้ใช้เวลากี่นาที"
														class="mb-2"
													/> -->
													<mapRouteItem
														v-for="direction in getDirectionList"
														:key="direction.destination.place_id"
														:place-selected="route_placeSelected"
														:mode-selected="route_modeSelected"
														:direction="direction"
														:origin="propLocation"
														:set-route="setRoute"
													/>
												</div>
											</v-col>
											<v-col cols="12">
												<placeGroupByType
													v-for="(places, i) in nearbyPlaceIn('communications')"
													:key="i"
													:places="places"
													:open-info="openInfoWindow"
													:close-info="closeInfoWindow"
												/>
											</v-col>
										</v-row>
									</v-card-text>
									<v-card-actions style="position: relative;">
										<v-overlay
											opacity="0"
											:absolute="true"
											:value="fullscreenMap && overlay"
											class="mapInfoOverlay"
										>
											<v-progress-linear
												class="mt-12"
												buffer-value="0"
												color="black"
												height="7"
												stream
											/>
											<h4>กำลังตรวจสอบสถานที่ใกล้เคียง</h4>
											<v-progress-linear
												color="black"
												buffer-value="0"
												height="7"
												stream
											/>
										</v-overlay>
									</v-card-actions>
								</v-card>
							</v-tab-item>

							<v-tab-item value="local_place">
								<v-card flat>
									<v-card-text class="pt-3 pb-0">
										<placeGroupByType
											v-for="(places, i) in nearbyPlaceIn(['local_place', 'lifestyle'])"
											:key="i"
											:places="places"
											:open-info="openInfoWindow"
											:close-info="closeInfoWindow"
										/>
									</v-card-text>
									<v-overlay
										opacity="0"
										:absolute="true"
										:value="fullscreenMap && overlay"
										class="mapInfoOverlay"
									>
										<v-progress-linear
											class="mt-12"
											buffer-value="0"
											color="black"
											height="7"
											stream
										/>
										<h4>กำลังตรวจสอบสถานที่ใกล้เคียง</h4>
										<v-progress-linear
											color="black"
											buffer-value="0"
											height="7"
											stream
										/>
									</v-overlay>
								</v-card>
							</v-tab-item>

							<!-- <v-tab-item value="lifestyle">
								<v-card flat>
									<v-card-text class="pt-3 pb-0">
										<placeGroupByType
											v-for="(places, i) in nearbyPlaceIn('lifestyle')"
											:key="i"
											:places="places"
											:open-info="openInfoWindow"
											:close-info="closeInfoWindow"
										/>
									</v-card-text>
									<v-overlay
										opacity="0"
										:absolute="true"
										:value="fullscreenMap && overlay"
										class="mapInfoOverlay"
									>
										<v-progress-linear
											class="mt-12"
											buffer-value="0"
											color="black"
											height="7"
											stream
										/>
										<h4>กำลังตรวจสอบสถานที่ใกล้เคียง</h4>
										<v-progress-linear
											color="black"
											buffer-value="0"
											height="7"
											stream
										/>
									</v-overlay>
								</v-card>
							</v-tab-item> -->
						</v-tabs-items>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<v-row no-gutters>
			<v-col
				cols="12"
				md="4"
				style="position: relative;"
			>
				<div class="container searchMTemp">
					<v-row>
						<v-col>
							<div class="searchMobile pr-0">
								<h5>ค้นหาสถานที่</h5>
								<div class="content">
									<nearbyAutocomplete
										:property-location="propLocation"
										:place-selected="onPlaceSelected"
										class="mb-2 placeSearch"
									/>
									<mapRouteItem
										v-for="direction in getDirectionList"
										:key="direction.destination.place_id"
										:place-selected="route_placeSelected"
										:mode-selected="route_modeSelected"
										:direction="direction"
										:origin="propLocation"
										:set-route="setRoute"
									/>
									<!-- <v-divider class="mt-8" />
									<v-btn
										width="100%"
										class="btnMain"
										text
										@click="mapExpand('communications')"
									>
										การเดินทาง
									</v-btn>
									<v-divider />
									<v-btn
										width="100%"
										class="btnMain"
										text
										@click="mapExpand('local_place')"
									>
										สถานที่ใกล้เคียง
									</v-btn>
									<v-divider />
									<v-btn
										v-if="false"
										width="100%"
										class="btnMain"
										text
										@click="mapExpand('lifestyle')"
									>
										อื่นๆ
									</v-btn>
									<v-divider /> -->
									<div class="d-flex mt-5">
										<v-btn
											class="btn-red-gradient white--text flex-grow-1"
											depressed
											tile
											@click="mapExpand('communications')"
										>
											การเดินทาง
										</v-btn>
										<v-btn
											class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
											depressed
											tile
											@click="mapExpand('communications')"
										>
											<v-icon>
												mdi-arrow-right
											</v-icon>
										</v-btn>
									</div>
									<div class="d-flex mt-2">
										<v-btn
											class="btn-red-gradient white--text flex-grow-1"
											depressed
											tile
											@click="mapExpand('local_place')"
										>
											สถานที่ใกล้เคียง
										</v-btn>
										<v-btn
											class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
											depressed
											tile
											@click="mapExpand('local_place')"
										>
											<v-icon>
												mdi-arrow-right
											</v-icon>
										</v-btn>
									</div>
								</div>
							</div>
						</v-col>
					</v-row>
				</div>
			</v-col>
			<v-col
				cols="12"
				md="8"
			>
				<div
					id="googleMap"
					ref="googleMap"
				>
					<iframe
						:src="embedURL"
						style="border: 0px none; width: 100%; height: 100%;"
						allowfullscreen=""
						loading="lazy"
					/>
				</div>
			</v-col>
		</v-row>

		<v-overlay
			opacity="0.4"
			:absolute="true"
			:value="fullscreenMap && overlay"
			class="googleMapOverlay"
		>
			<v-progress-linear
				class="mt-12"
				buffer-value="0"
				color="black"
				height="7"
				stream
			/>
			<h3>กำลังตรวจสอบสถานที่ใกล้เคียง</h3>
			<v-progress-linear
				color="black"
				buffer-value="0"
				height="7"
				stream
			/>
		</v-overlay>
		<v-container class="menu-bar py-0">
			<v-row no-gutters>
				<v-col>
					<v-btn
						v-if="!isPresentationMode"
						color="red"
						class="map-location-overlay px-2"
						title="ตำแหน่งของทรัพย์นี้"
						dark
						small
						:href="'http://maps.google.com/maps?q=' + propLocationString"
						target="_blank"
					>
						<v-icon
							class="mr-1"
							small
						>
							mdi-map-marker
						</v-icon>
						แชร์ Location
					</v-btn>
					<!-- <v-btn
						v-if="!isPresentationMode"
						color="red"
						class="map-direction-overlay px-1"
						title="นำทางไปยังทรัพย์นี้"
						width="36"
						height="36"
						fab
						dark
						small
						:href="'http://maps.google.com/maps?daddr=' + propLocationString"
						target="_blank"
					>
						<v-icon>mdi-directions</v-icon>
					</v-btn> -->
					<v-btn
						class="expand-map-btn ml-auto px-2"
						color="red"
						small
						:on-click="`fbq('track', 'OpenMap.Property.${property.id}');`"
						@click="mapExpand()"
					>
						เปิดแผนที่
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
		<!-- <div class="container searchMTemp">
			<v-row>
				<v-col>
					<div class="searchMobile pr-0">
						<h5>ค้นหาสถานที่</h5>
						<div class="content">
							<nearbyAutocomplete
								:property-location="propLocation"
								:place-selected="onPlaceSelected"
								class="mb-2 placeSearch"
							/>
							<mapRouteItem
								v-for="direction in getDirectionList"
								:key="direction.destination.place_id"
								:place-selected="route_placeSelected"
								:mode-selected="route_modeSelected"
								:direction="direction"
								:origin="propLocation"
								:set-route="setRoute"
							/>
							<v-divider class="mt-8" />
							<v-btn
								width="100%"
								class="btnMain"
								text
								@click="mapExpand('communications')"
							>
								การเดินทาง
							</v-btn>
							<v-divider />
							<v-btn
								width="100%"
								class="btnMain"
								text
								@click="mapExpand('local_place')"
							>
								สถานที่ใกล้เคียง
							</v-btn>
							<v-divider />
							<v-btn
								v-if="false"
								width="100%"
								class="btnMain"
								text
								@click="mapExpand('lifestyle')"
							>
								อื่นๆ
							</v-btn>
							<v-divider />
						</div>
					</div>
				</v-col>
			</v-row>
		</div> -->
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import nearbyAutocomplete from '~/components/2.0/nearby-autocomplete'
import placeGroupByType from '~/components/place-group-by-type'
import mapRouteItem from '~/components/map-route-item'

export default {
	components: {
		nearbyAutocomplete,
		placeGroupByType,
		mapRouteItem
	},

	props: {
		expand: {
			type: Boolean,
			default: false
		},
		property: {
			type: Object,
			default: () => null
		},
	},

	data: () => ({
		snackbar: false,
		snackbarText: '',
		mounted: false,
		overlay: true,
		google: null,
		map: null,
		mapOpened: false,
		coordinateValid: false,
		directionsService: null,
		directionsRenderer: null,
		openedInfoWindow: null,
		nearbyPlace: [],
		placeMarker: {
			communications: [],
			local_place: [],
			lifestyle: []
		},
		propLocation: null,

		fullscreenMap: null,
		placeTypeTab: 'communications',
		circleRadius: null,

		route_placeSelected: null,
		route_modeSelected: null,

		mapShare: false,
		mapShareX: 0,
		mapShareY: 0
	}),

	computed: {
		...mapGetters({getDirectionList: 'map/getDirectionList'}),

		propLocationString () {
			if (this.propLocation) {
				return `${this.propLocation.lat()},${this.propLocation.lng()}`
			}
			return ''
		},

		shareParams () {
			return this.$route.query.focus ? '' : '?focus=map'
		},

		isPresentationMode () {
			return this.$route.path.indexOf('/property-presentation') === 0
		},

		embedURL () {
			if (this.property && this.property.coordinates) {
				let coordinates = (this.property.coordinates || '').trim()
				let mapScale = 591657550.500000 / Math.pow(2, 12.6) // 11.6 + 1, the gratest number that no other pin
				let base64 = btoa([...coordinates.split(',')])
				return 'https://www.google.com/maps/embed?key=asdfsdfsf&pb=!1m7!1m2!1m1!1d' + mapScale + '!3m3!1m2!1s0!2z' + base64
			}

			return ''
		}
	},

	watch: {
		expand (isExpand) {
			if (isExpand) {
				this.mapExpand()
			} else {
				this.exitFullScreen()
			}
		},

		google () {
			if (this.mounted) {
				// Initial google map
				this.googleMapInit()
			}
		},

		mounted (isMounted) {
			if (isMounted && this.google) {
				this.googleMapInit()
			}
		},

		placeTypeTab (newVal, oldVal) {
			this.hideMarker(oldVal)
			this.showMarker(newVal)
		}
	},

	created () {
		// this.googleInit() // init when real use
	},

	mounted () {
		this.mounted = true
	},

	methods: {

		...mapActions({
			addDirection: 'map/addDirection',
			onRemoveDirection: 'map/onRemoveDirection'
		}),

		async onPlaceSelected (place) {
			if (!this.google) {
				await this.googleInit()
			}

			let transit = this.getRoute(this.propLocation, place.geometry.location, 'TRANSIT')
			let driving = this.getRoute(this.propLocation, place.geometry.location, 'DRIVING')

			// Transit by default (the last one will be set)
			Promise.all([driving, transit]).then(results => {
				// Store route in state
				let routeForRender = null
				let mode = 'TRANSIT'
				for(let result of results) {
					this.addDirection({
						origin: this.propLocation,
						destination: place,
						route: result.route,
						travelMode: result.travelMode
					})
					if(result.route) {
						routeForRender = result.route
						mode = result.travelMode
					}
				}
				if(routeForRender) {
					this.directionsRenderer.setDirections(routeForRender)
					this.route_placeSelected = place.place_id
					this.route_modeSelected = mode
				}
			})
		},

		async googleInit () {
			// Init google api
			await this.$googleMapsLoader.load(google => {

				let coordinates = (this.property.coordinates || '').trim()
				if (/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(coordinates)) {
					this.coordinateValid = true
				} else {
					coordinates = '13.729937454993, 100.57084231416'
				}
				// Property location
				this.propLocation = new google.maps.LatLng(...coordinates.split(','))
				this.google = google
			})
		},

		googleMapInit () {

			// Property location
			var map = new this.google.maps.Map(this.$refs.googleMap, {
				center: this.propLocation,
				gestureHandling: 'greedy',
				zoom: 15,
				styles: [{
					'featureType': 'poi',
					'stylers': [
						{ 'visibility': 'off' }
					]
				}],
				mapTypeControlOptions: {
					style: this.google.maps.MapTypeControlStyle.DROPDOWN_MENU,
					// mapTypeIds: ['roadmap', 'terrain']
				},
				// zoomControlOptions: {
				// 	position: this.google.maps.ControlPosition.RIGHT_TOP
				// },
				// streetViewControlOptions: {
				// 	position: this.google.maps.ControlPosition.LEFT_BOTTOM
				// },
			})
			this.map = map

			if (this.coordinateValid) {

				// Property marker
				new this.google.maps.Marker({
					position: this.propLocation,
					map: map
				})

				// Direction service
				this.directionsService = new this.google.maps.DirectionsService()
				this.directionsRenderer = new this.google.maps.DirectionsRenderer()
				this.directionsRenderer.setMap(map)

				// Place search autocomplete
				// var autocomplete = new this.google.maps.places.Autocomplete(this.$refs.placeSearch.$refs.input, {
				// 	origin: this.propLocation,
				// 	componentRestrictions: { country: 'th' }
				// })
				// autocomplete.addListener('place_changed', () => {
				// 	let place = autocomplete.getPlace()
				// 	this.$refs.placeSearch.$refs.input.value = ''

				// 	let transit = this.getRoute(this.propLocation, place.geometry.location, 'TRANSIT')
				// 	let driving = this.getRoute(this.propLocation, place.geometry.location, 'DRIVING')

				// 	// Transit by default (the last one will be set)
				// 	Promise.all([driving, transit]).then(routes => {
				// 		// Store route in state
				// 		let routeForRender = null
				// 		for(let route of routes) {
				// 			if(route) {
				// 				this.addDirection({
				// 					origin: this.propLocation,
				// 					destination: place,
				// 					route: route
				// 				})
				// 				routeForRender = route
				// 			}
				// 		}
				// 		if(routeForRender) {
				// 			this.directionsRenderer.setDirections(routeForRender)
				// 			this.route_placeSelected = place.place_id
				// 			this.route_modeSelected = 'TRANSIT'
				// 		}
				// 	})
				// })

				// Circle radius
				this.circleRadius = new this.google.maps.Circle({
					strokeColor: '#FF0000',
					strokeOpacity: 0.15,
					strokeWeight: 1,
					fillColor: '#FF0000',
					fillOpacity: 0.08,
					map: map,
					center: this.propLocation,
					radius: 3000, // 3km.
					visible: false
				})

				if (this.expand) {
					this.mapExpand()
				}
			}
		},

		async findNearByPlace (times = 1) {

			const places = [
				// communications
				{
					group: 'communications',
					icon: 'train',
					label: 'รถไฟฟ้า',
					type: 'mrt',
					types: ['subway_station'],
				},
				{
					group: 'communications',
					icon: 'bus',
					label: 'รถประจำทาง',
					type: 'bus',
					types: ['bus_station']
				},

				// local_place
				{
					group: 'local_place',
					icon: 'cart',
					label: 'ห้างสรรพสินค้า',
					type: 'shopping_mall',
					// types: ['shopping_mall', 'department_store']
					types: ['shopping_mall']
				},
				{
					group: 'local_place',
					icon: 'store',
					label: 'ซุปเปอร์มาเก็ต',
					type: 'supermarket',
					// types: ['grocery_or_supermarket', 'supermarket']
					types: ['supermarket']
				},
				{
					group: 'local_place',
					icon: 'silverware-variant',
					label: 'ร้านอาหาร และ ผับ',
					type: 'restaurant',
					// types: ['restaurant', 'night_club', 'bar', 'cafe']
					types: ['restaurant']
				},
				{
					group: 'local_place',
					icon: 'school',
					label: 'โรงเรียน',
					type: 'school',
					// types: ['school', 'primary_school', 'secondary_school']
					types: ['school']
				},
				{
					group: 'local_place',
					icon: 'hospital',
					label: 'คลินิก และ โรงพยาบาล',
					type: 'hospital',
					// types: ['hospital', 'drugstore']
					types: ['hospital']
				},
				{
					group: 'local_place',
					icon: 'bank',
					label: 'สถานที่ทางศาสนา',
					type: 'church',
					// types: ['place_of_worship', 'hindu_temple', 'church', 'synagogue']
					types: ['church']
				},

				// lifestyle
				{
					group: 'lifestyle',
					icon: 'flower',
					label: 'สวนสาธารณะ และ ยิม',
					type: 'park_gym',
					types: ['park', 'gym']
				}
				// {
				// 	group: 'lifestyle',
				// 	icon: 'filmstrip',
				// 	label: 'โรงภาพยนตร์',
				// 	type: 'movie_theater',
				// 	types: ['movie_theater']
				// },
				// {
				// 	group: 'lifestyle',
				// 	icon: 'cash-usd',
				// 	label: 'ตู้ ATM',
				// 	type: 'atm',
				// 	types: ['atm']
				// },
				// {
				// 	group: 'lifestyle',
				// 	icon: 'email',
				// 	label: 'ตู้ไปรษณีย์',
				// 	type: 'postal',
				// 	// types: ['post_office', 'post_box']
				// 	types: ['post_office']
				// }
			]

			const STATUS_OK = this.google.maps.places.PlacesServiceStatus.OK
			let request = {
				location: this.propLocation,
				fields: ['geometry/location', 'name'],
				radius: 3000,
				language: 'th',
				// rankby: 'distance',
				// rankby: 'PROMINENCE',
				type: []
			}
			let allQuery = []
			// let placeService = places.map(() => new this.google.maps.places.PlacesService(this.map))
			let placeService = new this.google.maps.places.PlacesService(this.map)
			// let distanceMatrixService = new this.google.maps.DistanceMatrixService()
			// Need to delay request according to google request limit
			for(let i = 0; i < places.length; ++i) {

				(function(i) {
					allQuery.push(new Promise((resolve, reject) => {
						let delay = 2000 * Math.floor(i / 10)

						setTimeout(() => {
							const item = places[i]
							request.type = item.types

							placeService.nearbySearch(request, (results, status/*, pagination*/) => {
								if(status === STATUS_OK) {

									results = results.filter(place => (place.geometry.location.lat() !== 13.7563309 && place.geometry.location.lng() !== 100.50176510000006))
									if (results.length === 0) {
										resolve(null)
									} else {
										resolve({
											group: item.group,
											icon: item.icon,
											label: item.label,
											type: item.type,
											list: results.map(place => ({
												location: { // close this on no use of distance finding
													lat: place.geometry.location.lat(),
													lng: place.geometry.location.lng()
												},
												// location: place.geometry.location, // open this if need of distance finding
												name: place.name
											}))
										})
									}
								} else if (status === 'ZERO_RESULTS') {
									resolve(null)
								} else {
									reject(request)
								}
							})
						}, delay)
					}))
				})(i)
			}

			await Promise.all(allQuery).then(nearbyList => {
				nearbyList = nearbyList.filter(item => item !== null)

				/* no distance, no duration for reduce cost
				allQuery = []
				let elmCount = 0
				for(let types of nearbyList) {

					allQuery.push(new Promise((resolve, reject) => {
						elmCount += types.list.length
						let delay = 2000 * Math.floor(elmCount / 20)

						setTimeout(() => {
							// Distance matrix
							distanceMatrixService.getDistanceMatrix({
								origins: [this.propLocation],
								destinations: [...types.list.map(place => place.location)],
								travelMode: 'WALKING',
							}, (response, status) => {

								if (status === 'OK') {
									let elements = response.rows[0].elements
									for(let i in types.list) {
										types.list[i] = {
											name: types.list[i].name,
											location: {
												lat: types.list[i].location.lat(),
												lng: types.list[i].location.lng()
											},
											distance: elements[i].distance,
											duration: elements[i].duration
										}
									}

									resolve(types)
								} else {
									console.log(status)
									reject(status)
								}
							})
						}, delay)
					}))
				}

				Promise.all(allQuery).then(nearbyList => {

					this.$fireStore.collection('property').doc(this.property.id.toString()).set({
						nearby: nearbyList
					}).then(() => {
						console.log('Document successfully written!')
					}).catch(error => {
						console.error('Error writing document: ', error)
					}).finally(() => {
						this.nearbyPlace = nearbyList
						this.property.nearby = nearbyList
						this.markerRender()
						this.overlay = false
					})
				}).catch(() => {
					if (times < 3) {
						// Try again(only 3 times)
						setTimeout(this.findNearByPlace.bind(null, times + 1), 1500)
					} else {
						this.overlay = false
					}
				})
				*/

				// remove this if above code is using
				this.$fireStore.collection('property').doc(this.property.id.toString()).set({
					nearby: nearbyList
				}).then(() => {
					console.log('Document successfully written!')
				}).catch(error => {
					console.error('Error writing document: ', error)
				}).finally(() => {
					this.overlay = false
				})
				this.nearbyPlace = nearbyList
				this.property.nearby = nearbyList
				this.markerRender()
			}).catch(() => {
				if (times < 3) {
					// Try again(only 3 times)
					setTimeout(this.findNearByPlace.bind(null, times + 1), 1500)
				} else {
					this.overlay = false
				}
			})

			// ----

			// Place search
			// let request = {
			// 	fields: ['geometry/location', 'name'],
			// 	// locationBias: {
			// 	// 	radius: 1000,
			// 	// 	center: this.propLocation
			// 	// },
			// 	location: propLocation,
			// 	radius: 1000,
			// 	language: 'th',
			// 	type: ['school']
			// }
			// let service = new this.google.maps.places.PlacesService(map);
			// service.textSearch(request, (results, status, pagination) => {
			// 	if((status === this.google.maps.places.PlacesServiceStatus.OK)) {

			// 		this.tmpNearby.push(...results.map(place => ({
			// 			location: place.geometry.location,
			// 			name: place.name
			// 		})))

			// 		if(pagination.hasNextPage) {
			// 			setTimeout(() => {
			// 				pagination.nextPage()
			// 			}, 2000)
			// 		} else {
			// 			console.log(JSON.stringify(this.tmpNearby))
			// 		}
			// 	}
			// })
		},

		getNearbyInfo () {
			if (this.coordinateValid) {
				if (this.property && !this.property.nearby) {
					this.$fireStore.collection('property').doc(this.$route.params.id).get().then(async doc => {
						if (doc.exists) {
							this.nearbyPlace = doc.data().nearby
							this.property.nearby = doc.data().nearby
							this.markerRender()
							// this.showMarker(this.placeTypeTab)
							this.overlay = false
						} else {
							await this.findNearByPlace()
						}
						this.showMarker(this.placeTypeTab)
					})
				} else if (this.property) {
					this.nearbyPlace = this.property.nearby
					this.markerRender()
					this.showMarker(this.placeTypeTab)
					this.overlay = false
				}
			} else {
				// Invalid coordinates
				this.overlay = false
			}
		},

		markerRender () {
			// Place marker
			var refIndex
			for(let groups of this.nearbyPlace) {
				refIndex = 0
				for(let place of groups.list) {
					let elmID = groups.type + '_' + (refIndex++)
					let marker = new this.google.maps.Marker({
						position: place.location,
						map: this.map,
						title: place.name,
						// icon: groups.icon,
						icon: {
							url: '/images/icon/' + groups.icon + '.svg',
							size: new this.google.maps.Size(25, 25),
							origin: new this.google.maps.Point(0, 0),
							anchor: new this.google.maps.Point(11, 10),
							scaledSize: new this.google.maps.Size(25, 25)
						},
						visible: false
					})
					marker.addListener('mouseover', () => {
						this.openInfoWindow(place)

						let el = document.getElementById(elmID)
						if (el) {
							el.className = 'focused'
						}
					})
					marker.addListener('mouseout', () => {
						this.closeInfoWindow()

						let el = document.getElementById(elmID)
						if (el) {
							el.className = ''
						}
					})

					this.placeMarker[groups.group].push(marker)
				}
			}
		},

		async mapExpand (openTab = this.placeTypeTab) {
			this.fullscreenMap = 'fullscreen'
			if (!this.google) {
				await this.googleInit()
			}
			// if (!this.mapOpened) {
			// 	this.mapOpened = true
			// 	await this.googleInit()
			// 	this.getNearbyInfo()
			// }

			if (this.circleRadius) {
				this.circleRadius.setVisible(true)
			}
			document.getElementsByTagName('html')[0].className += ' fullscreen'

			if (openTab !== this.placeTypeTab) {
				this.placeTypeTab = openTab
				// setTimeout(() => {
				// 	this.placeTypeTab = openTab
				// }, 1)
			} else {
				this.showMarker(this.placeTypeTab)
			}

			if (!this.mapOpened) {
				this.mapOpened = true
				this.getNearbyInfo()
			}
		},
		exitFullScreen () {
			this.fullscreenMap = null
			if (this.circleRadius) {
				this.circleRadius.setVisible(false)
			}
			this.hideMarker(this.placeTypeTab)
			let cls = document.getElementsByTagName('html')[0].className
			document.getElementsByTagName('html')[0].className = cls.replace(
				' fullscreen',
				''
			)
			if (this.$route.query.focus) {
				let query = { ...this.$route.query }
				delete query.focus
				this.$router.replace({ query })
			}
		},

		showMarker (group) {
			if (group) {
				let place = (group === 'local_place' ? [...this.placeMarker['local_place'], ...this.placeMarker['lifestyle']] : this.placeMarker[group])
				for(let marker of place) {
					marker.setVisible(true)
				}
			}
		},
		hideMarker (group) {
			if (group) {
				let place = (group === 'local_place' ? [...this.placeMarker['local_place'], ...this.placeMarker['lifestyle']] : this.placeMarker[group])
				for(let marker of place) {
					marker.setVisible(false)
				}
			}
		},

		openInfoWindow (place) {
			let infowindow = new this.google.maps.InfoWindow({
				content: `<div>${place.name}</div>`,
				maxWidth: 200
			})
			infowindow.setPosition(place.location)
			infowindow.setZIndex(9999)
			infowindow.open(this.map)
			this.openedInfoWindow = infowindow
		},
		closeInfoWindow () {
			this.openedInfoWindow.close()
		},

		nearbyPlaceIn (group) {
			if (typeof group === 'string') {
				group = [ group ]
			}
			return this.nearbyPlace.filter(place => group.includes(place.group))
		},

		getRoute (origin, destination, travelMode) {
			return new Promise((resolve) => {
				this.directionsService.route({ origin, destination, travelMode }, (result, status) => {
					if (status === 'OK') {
						resolve({
							route: result,
							travelMode
						})
					} else {
						resolve({
							route: null,
							travelMode
						})
					}
				})
			})
		},
		async setRoute (route, place, mode) {
			if (!this.google) {
				await this.googleInit()
			}

			if (route && route[mode]) {
				let r = route[mode]
				// if (typeof route[mode].request.origin.location.lat  === 'number') {
				// 	r = {
				// 		geocoded_waypoints: [...route[mode].geocoded_waypoints],
				// 		status: route[mode].status,
				// 		routes: [{
				// 			bounds: route[mode].routes[0].bounds,
				// 			copyrights: route[mode].routes[0].copyrights,
				// 			overview_polyline: route[mode].routes[0].overview_polyline,
				// 			summary: route[mode].routes[0].summary,
				// 			warnings: [...route[mode].routes[0].warnings],
				// 			waypoint_order: [...route[mode].routes[0].waypoint_order],
				// 			overview_path: route[mode].routes[0].overview_path.map(loc => new this.google.maps.LatLng(loc.lat, loc.lng)),
				// 			legs: [{
				// 				distance: route[mode].routes[0].legs[0].distance,
				// 				duration: route[mode].routes[0].legs[0].duration,
				// 				end_address: route[mode].routes[0].legs[0].end_address,
				// 				end_location: new this.google.maps.LatLng(route[mode].routes[0].legs[0].end_location.lat, route[mode].routes[0].legs[0].end_location.lng),
				// 				start_address: route[mode].routes[0].legs[0].start_address,
				// 				start_location: new this.google.maps.LatLng(route[mode].routes[0].legs[0].start_location.lat, route[mode].routes[0].legs[0].start_location.lng),
				// 				traffic_speed_entry: route[mode].routes[0].legs[0].traffic_speed_entry,
				// 				via_waypoint: route[mode].routes[0].legs[0].via_waypoint,
				// 				via_waypoints: route[mode].routes[0].legs[0].via_waypoints,
				// 				steps: route[mode].routes[0].legs[0].steps.map(item => ({
				// 					distance: item.distance,
				// 					duration: item.duration,
				// 					end_location: new this.google.maps.LatLng(item.end_location.lat, item.end_location.lng),
				// 					polyline: item.polyline,
				// 					start_location: new this.google.maps.LatLng(item.start_location.lat, item.start_location.lng),
				// 					travel_mode: mode,
				// 					encoded_lat_lngs: item.encoded_lat_lngs,
				// 					path: item.path.map(loc => new this.google.maps.LatLng(loc.lat, loc.lng)),
				// 					lat_lngs: item.lat_lngs.map(loc => new this.google.maps.LatLng(loc.lat, loc.lng)),
				// 					instructions: item.instructions,
				// 					maneuver: item.maneuver,
				// 					start_point: new this.google.maps.LatLng(item.start_point.lat, item.start_point.lng),
				// 					end_point: new this.google.maps.LatLng(item.start_point.lat, item.start_point.lng),
				// 				}))
				// 			}]
				// 		}],
				// 		request: {
				// 			travelMode: mode,
				// 			origin: {
				// 				location: new this.google.maps.LatLng(route[mode].request.origin.location.lat, route[mode].request.origin.location.lng)
				// 			},
				// 			destination: {
				// 				location: new this.google.maps.LatLng(route[mode].request.destination.location.lat, route[mode].request.destination.location.lng)
				// 			}
				// 		}
				// 	}
				// }
				if (this.directionsRenderer) {
					this.directionsRenderer.setDirections(r)
					this.route_placeSelected = place.place_id
					this.route_modeSelected = mode
				}
			} else if (mode) {
				if (this.directionsRenderer) {
					let placeLocation = new this.google.maps.LatLng(place.geometry.location.lat, place.geometry.location.lng)
					this.getRoute(this.propLocation, placeLocation, mode).then(result => {
						this.directionsRenderer.set('directions', result.route)
						this.addDirection({
							origin: this.propLocation,
							destination: place,
							route: result.route,
							travelMode: result.travelMode
						})

						this.route_placeSelected = place.place_id
						this.route_modeSelected = mode
					})
				}
			} else {
				// Remove route
				if (this.directionsRenderer) {
					this.directionsRenderer.set('directions', null)
				}
			}
		},

		mapShareShow (event) {
			event.preventDefault()
			let rect = this.$refs.mapShareBtn.$el.getBoundingClientRect()
			this.mapShare = false
			this.mapShareX = rect.right
			this.mapShareY = rect.bottom
			this.$nextTick(() => {
				this.mapShare = true
			})
		},

		copyText(ref, getParams) {
			ref.className = ''
			ref.value = window.location.origin + this.$route.fullPath + (getParams ? `${getParams}` : '')
			ref.focus()
			ref.select()

			try {
				document.execCommand('copy')
				this.snackbarText = 'คัดลอกแล้ว'
			} catch (err) {
				console.log('Oops, unable to copy')
				this.snackbarText = 'ไม่สามารถคัดลอกได้'
			} finally {
				ref.blur()
				ref.value = ''
				ref.className = 'd-none'

				this.snackbar = true
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.borderBoxShadow { border-radius: 5px; box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12); padding: 15px 10px; }
.detailLists {
  a { background: rgb(231, 231, 231); border-left: 2px solid rgb(165, 165, 165); display: block; margin-bottom: 3px; padding: 5px 10px; text-decoration: none; }
  h5 { font-size: 0.9em; font-weight: 400; margin-bottom: 0;
    i { font-size: 0.9em; height: auto; }
  }
  i { height: 100%; vertical-align: middle; }
  p { overflow: hidden; height: 44px; margin-bottom: 0; }
}
.map-location-overlay {
	position: absolute;
	top: 10px;
	right: 75px;
	text-transform: capitalize;
}
.map-direction-overlay {
	position: absolute;
	top: 10px;
	right: 107px;
}
.map-direction {
	display: none;
	position: fixed;
	top: 10px;
	right: 160px;
	z-index: 1000;
}
.map-share {
	display: none;
	position: fixed;
	top: 10px;
	right: 110px;
	z-index: 1000;
}
.exit-fullscreen {
	display: none;
	position: fixed;
	top: 10px;
	right: 60px;
	z-index: 1000;
}
#map {
	position: relative;
}
.near-by-list {
	display: none;
	position: fixed;
	left:0;
	top: 0;
	height: 100vh;
	width: 320px;
  z-index: 999;
  .v-tab { padding: 0; }
}
#map.fullscreen .near-by-list {
	display: inline;
}
#googleMap {
	height: 500px;
}
#map.fullscreen {

	.exit-fullscreen, .map-share, .map-direction {
		display: inline-flex;
	}
	#googleMap, .googleMapOverlay {
		top: 0;
		right: 0;
		position: fixed !important;
		width: calc(100vw - 320px);
		height: 100vh;
		z-index: 999 !important;
	}
	.googleMapOverlay {
		left: unset !important;
		text-shadow: 2px 1px 2px black;

		&::v-deep .v-progress-linear__stream {
			opacity: 0.75 !important;
		}
	}
	.mapInfoOverlay {
		bottom: unset !important;
		color: black;
	}
}

.menu-bar {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
  width: 100%;
  z-index: 3;

	& > div > div {
		position: relative;
		padding: 0;

		.expand-map-btn {
			position: absolute;
			top: 10px;
			right: 0;
			color: white;
		}
	}
}
.moblieMenutab { display: none; }

.mapType {
  button { height: 60px!important; overflow: hidden; padding: 0!important; }
}
.searchMobile::v-deep {
	background: #eee;
	padding: 15px;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;

  h5 { color: rgb(158, 158, 158); margin-bottom: 5px; }
  .content { height: 445px; padding-right: 15px; overflow-y: auto; overflow-x: hidden; }
  .btnMain {
    span { display: block; text-align: left; }
  }
  .placeSearch { font-size: 0.9em; }
}
.searchMTemp { position: absolute; top: 0; left: 0; right: 0; height: 0; width: 100%; z-index: 2; padding: 0;
  > div > div { position: absolute; top: 0; left: 0; right: 0; height: 0; width: 100%; z-index: 2; padding: 0; }
}

.tabLayout::v-deep {
  .v-tabs-items {
		height: calc(100vh - 80px);
		overflow-y: auto;
	}
}
.travelBtn {
  button { height: 60px!important; padding: 0 3px!important; width: 100%; }
}

.menutab { display: none; }

::v-deep .v-tabs-bar {
	height: 36px !important;
}

@media (max-width: 959px) {
	#googleMap {
		height: 400px;
	}
	#map.fullscreen {

		#googleMap {
			position: fixed !important;
			height: 35vh;
			width: 100%;
		}
		.googleMapOverlay {
			width: 100vw;
			height: 35vh;
		}
	}
	.near-by-list {
		background: #fff;
		top: 35vh;
		left: 0;
		position: fixed !important;
		width: 100%;
		height: 65vh;
		overflow-y: auto;
		z-index: 999;
	}
	.searchMobile { position: relative; top: 0; left: 0; width: 100%;
		.content { height: auto; }
	}
	.searchMTemp { position: relative; top: 0; left: 0; right: 0; height: auto; widows: 100%; z-index: 2;
		> div > div { position: relative; top: 0; left: 0; right: 0; height: auto; widows: 100%; z-index: 2; padding: 20px 15px; }
	}
	.tabLayout::v-deep {
		.v-tabs-items {
			overflow-y: unset;

			.v-window-item {
				margin-bottom: 75px;
			}
		}
	}
}

@media (min-width: 1264px) and (max-width: 1903px) {
}

</style>
